<template>
  <tbody class="cart-promotion">
    <tr>
      <td class="hidden-xs" />
      <td :colspan="colspan" class="promotion-name">{{ name }}</td>
      <td colspan="2" class="lead">{{ amount }}</td>
    </tr>
  </tbody>
</template>

<script>
  export default {
    props: {
      name: { type: String, required: true },
      amount: { type: String, required: true }
    },
    computed: {
      colspan() {
        return this.$mq === "xs" ? 2 : 3
      }
    }
  }
</script>

<style lang="scss">
  #cart-form {
    .cart-promotion td {
      font-size: 16px;
    }

    .promotion-name {
      font-weight: 700;
      text-align: right;
    }
  }
</style>
